import React from "react";
import i18n from "i18next";
import styled from "styled-components";
import { connect } from "react-redux";
import TableComponent from "components/table/TableComponent";
import { TableData, TableColumnData, TableRowData } from "components/table/TableDataModel";
import { getPastDateString, deleteWlClient, reInviteWlClient, showToastTip, toastType } from "@kubera/common";
import { contextMenuItemType } from "components/contextmenu/ContextMenu";
import ConfirmationDialog from "components/dialog/ConfirmationDialog";

const Container = styled.div`
  display: flex;
  width: 100%;
`;

const ClientTable = styled(TableComponent)`
  width: 100%;
`;

const ClientNameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ClientCellName = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  font-feature-settings: "ss01" on, "calt" off;
`;

const ClientDescription = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  font-feature-settings: "ss01" on, "calt" off;
  color: rgba(0, 0, 0, 0.5);
`;

const EmptyTableContainer = styled.div`
  padding: 18px 20px 0px 50px;
`;

const InviteClientButton = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 130%;
  text-decoration-line: underline;
  font-feature-settings: "ss01" on;
  color: ${props => props.theme.linkColor};
  cursor: pointer;
`;

const EmptyTableDescription = styled.div`
  padding-top: 7px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  font-feature-settings: "ss01" on;
`;

const NoSearchResultsDescription = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 130%;
  font-feature-settings: "ss01" on;
`;

class InvitedClientsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showDeleteDialog: false, userToDelete: null };

    this.handleContextMenuSelection = this.handleContextMenuSelection.bind(this);
    this.handleDeleteConfirmation = this.handleDeleteConfirmation.bind(this);
    this.handleDeleteCancellation = this.handleDeleteCancellation.bind(this);
  }

  handleContextMenuSelection(item, row) {
    if (item.id === contextMenuItemType.DELETE.id) {
      this.setState({ showDeleteDialog: true, userToDelete: row.rowObject });
    } else if (item.id === contextMenuItemType.INVITE_AGAIN.id) {
      this.props.reInviteWlClient(row.rowObject);

      this.props.showToastTip(
        toastType.TIP,
        i18n.t("inviteSent"),
        null,
        5000,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        true
      );
    }
  }

  handleDeleteCancellation() {
    this.setState({ userToDelete: null, showDeleteDialog: false });
  }

  handleDeleteConfirmation() {
    this.setState({ showDeleteDialog: false });
    this.props.deleteWlClient(this.state.userToDelete);
  }

  getTableData() {
    const nameColumn = new TableColumnData(
      i18n.t("client"),
      i18n.t("client"),
      client => {
        return client.clientName;
      },
      client => {
        return (
          <ClientNameContainer>
            <ClientCellName>{client.clientName}</ClientCellName>
            <ClientDescription>{client.email}</ClientDescription>
          </ClientNameContainer>
        );
      },
      "string"
    );

    const invitedColumn = new TableColumnData(
      i18n.t("invited"),
      i18n.t("invited"),
      client => {
        return !client.tsReInvite === false ? client.tsReInvite : client.tsInvite;
      },
      client => {
        const timestamp = !client.tsReInvite === false ? client.tsReInvite : client.tsInvite;
        return getPastDateString(new Date(timestamp * 1000));
      }
    );

    const columns = [nameColumn, invitedColumn];

    const clients = this.props.clients;
    const rows = clients.map(
      client =>
        new TableRowData(client, row => {
          return [[contextMenuItemType.INVITE_AGAIN], [contextMenuItemType.DELETE]];
        })
    );
    return new TableData(columns, rows, invitedColumn.sortKey);
  }

  render() {
    const clients = this.props.clients;
    if (!clients === true || clients.length === 0) {
      if (!this.props.searchText === false) {
        return (
          <Container>
            <EmptyTableContainer>
              <NoSearchResultsDescription>{i18n.t("emptyClientSearchResults")}</NoSearchResultsDescription>
            </EmptyTableContainer>
          </Container>
        );
      }

      return (
        <Container>
          <EmptyTableContainer>
            <InviteClientButton onClick={this.props.onInviteButtonClick}>{i18n.t("inviteClient")}</InviteClientButton>
            <EmptyTableDescription>{i18n.t("emptyInvitedClientsDescription")}</EmptyTableDescription>
          </EmptyTableContainer>
        </Container>
      );
    }

    const tableData = this.getTableData();
    const showDeleteDialog = this.state.showDeleteDialog;
    return (
      <Container>
        <ClientTable data={tableData} onContextMenuSelection={this.handleContextMenuSelection} />
        {showDeleteDialog === true && (
          <ConfirmationDialog
            title={i18n.t("deleteUserDialog.title")}
            description={i18n.t("sure")}
            positiveButtonTitle={i18n.t("delete")}
            negativeButtonTitle={i18n.t("cancel")}
            handlePositiveButtonClick={this.handleDeleteConfirmation}
            handleNegativeButtonClick={this.handleDeleteCancellation}
          />
        )}
      </Container>
    );
  }
}

const mapDispatchToProps = {
  deleteWlClient: deleteWlClient,
  reInviteWlClient: reInviteWlClient,
  showToastTip: showToastTip
};

export default connect(
  null,
  mapDispatchToProps
)(InvitedClientsComponent);
